import { useEffect } from 'react';
import { createBrowserRouter, RouterProvider, Outlet, useLocation } from 'react-router-dom';
import { Sentry } from './lib/sentry';
import { capturePageview } from './lib/analytics';
import { LandingPage } from './pages/LandingPage';
import { LoginPage } from './pages/LoginPage';
import { RegisterPage } from './pages/RegisterPage';
import { ForgotPasswordPage } from './pages/ForgotPasswordPage';
import { ResetPasswordPage } from './pages/ResetPasswordPage';
import { VerifyPage } from './pages/VerifyPage';
import { TwoFactorChallengePage } from './pages/TwoFactorChallengePage';
import { AuthCallbackPage } from './pages/AuthCallbackPage';
import { DashboardPage } from './pages/DashboardPage';
import { BillingPage } from './pages/BillingPage';
import { SecuritySettingsPage } from './pages/SecuritySettingsPage';
import { AdminPage } from './pages/AdminPage';
import { ProtectedRoute } from './components/ProtectedRoute';
import { AppShell } from './components/layout';

function PageviewTracker() {
  const location = useLocation();
  useEffect(() => {
    capturePageview(location.pathname);
  }, [location.pathname]);
  return null;
}

const router = createBrowserRouter([
  {
    element: (
      <>
        <PageviewTracker />
        <Outlet />
      </>
    ),
    children: [
      // Routes wrapped with AppShell (sidebar visible)
      {
        element: (
          <AppShell>
            <Outlet />
          </AppShell>
        ),
        children: [
          { path: '/', element: <LandingPage /> },
          {
            element: <ProtectedRoute />,
            children: [
              { path: '/dashboard', element: <DashboardPage /> },
              { path: '/billing', element: <BillingPage /> },
              { path: '/settings/security', element: <SecuritySettingsPage /> },
            ],
          },
          {
            element: <ProtectedRoute role="admin" />,
            children: [{ path: '/admin', element: <AdminPage /> }],
          },
        ],
      },
      // Auth-flow routes — NO AppShell
      { path: '/login', element: <LoginPage /> },
      { path: '/register', element: <RegisterPage /> },
      { path: '/forgot-password', element: <ForgotPasswordPage /> },
      { path: '/reset-password', element: <ResetPasswordPage /> },
      { path: '/verify', element: <VerifyPage /> },
      { path: '/two-factor', element: <TwoFactorChallengePage /> },
      { path: '/auth/callback', element: <AuthCallbackPage /> },
    ],
  },
]);

export function App() {
  return (
    <Sentry.ErrorBoundary fallback={<p>Something went wrong.</p>}>
      <RouterProvider router={router} />
    </Sentry.ErrorBoundary>
  );
}
